export const categories = [
  { slug: 'shishang-chuanda', name: '时尚穿搭', icon: 'ri-t-shirt-line', description: '最新潮流穿搭指南，展现个性魅力' },
  { slug: 'shenghuo-xiezhen', name: '生活写真', icon: 'ri-camera-line', description: '记录生活美好瞬间，分享真实日常' },
  { slug: 'caiyi-zhanshi', name: '才艺展示', icon: 'ri-music-line', description: '舞蹈、歌唱、乐器等才艺精彩呈现' },
  { slug: 'meirong-meizhuang', name: '美容美妆', icon: 'ri-palette-line', description: '专业美妆教程与护肤心得分享' },
  { slug: 'jianshen-yundong', name: '健身运动', icon: 'ri-heart-pulse-line', description: '健康生活方式与运动日常记录' },
  { slug: 'luxing-meishi', name: '旅行美食', icon: 'ri-compass-line', description: '旅行足迹与美食探店精彩视频' },
];

export const featuredVideos = [
  {
    id: 'feat-1',
    title: '2026夏季时尚穿搭指南｜轻熟风日常搭配分享',
    category: '时尚穿搭',
    categorySlug: 'shishang-chuanda',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20stylish%20woman%20in%20fashionable%20summer%20outfit%2C%20soft%20natural%20lighting%2C%20minimalist%20warm%20cream%20background%2C%20editorial%20lifestyle%20photography%2C%20clean%20composition%2C%20beauty%20and%20fashion%20aesthetic%2C%20soft%20shadows%2C%20professional%20lighting%2C%20modern%20look&width=800&height=450&seq=featured-video-01&orientation=landscape',
    duration: '08:24',
    views: '128.6万',
    date: '2026-08-08',
    description: '夏季轻熟风搭配技巧全解析，从职场到约会一网打尽，教你穿出高级感。',
  },
  {
    id: 'feat-2',
    title: '海边度假写真｜夏日清新胶片风人像摄影',
    category: '生活写真',
    categorySlug: 'shenghuo-xiezhen',
    imageUrl: 'https://readdy.ai/api/search-image?query=Beautiful%20woman%20at%20tropical%20beach%20resort%2C%20summer%20vacation%20vibe%2C%20soft%20warm%20sunlight%2C%20film%20photography%20style%2C%20natural%20pose%2C%20clean%20ocean%20background%2C%20lifestyle%20aesthetic%2C%20minimalist%20composition&width=800&height=450&seq=featured-video-02&orientation=landscape',
    duration: '12:15',
    views: '96.3万',
    date: '2026-08-07',
    description: '跟随镜头感受海边度假的惬意时光，清新胶片风格人像写真拍摄全记录。',
  },
  {
    id: 'feat-3',
    title: '古典舞《惊鸿》完整版｜国风舞蹈才艺展示',
    category: '才艺展示',
    categorySlug: 'caiyi-zhanshi',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20female%20dancer%20in%20traditional%20Chinese%20dance%20costume%2C%20classical%20dance%20performance%2C%20flowing%20silk%20ribbons%2C%20soft%20dramatic%20lighting%2C%20minimalist%20dark%20background%2C%20artistic%20composition%2C%20graceful%20movement&width=800&height=450&seq=featured-video-03&orientation=landscape',
    duration: '06:48',
    views: '215.7万',
    date: '2026-08-06',
    description: '原创古典舞作品《惊鸿》，融合传统与现代元素，展现东方女性的柔美与力量。',
  },
  {
    id: 'feat-4',
    title: '日系清透妆容教程｜新手也能轻松掌握',
    category: '美容美妆',
    categorySlug: 'meirong-meizhuang',
    imageUrl: 'https://readdy.ai/api/search-image?query=Beautiful%20woman%20applying%20natural%20makeup%2C%20Japanese%20style%20clean%20look%2C%20soft%20daylight%20by%20window%2C%20minimalist%20vanity%20setup%2C%20warm%20neutral%20background%2C%20beauty%20tutorial%20aesthetic%2C%20fresh%20dewy%20skin&width=800&height=450&seq=featured-video-04&orientation=landscape',
    duration: '15:32',
    views: '89.2万',
    date: '2026-08-05',
    description: '零基础也能学会的日系清透裸妆教程，步骤详细讲解，打造自然好气色。',
  },
  {
    id: 'feat-5',
    title: '居家瑜伽跟练｜30分钟全身燃脂塑形',
    category: '健身运动',
    categorySlug: 'jianshen-yundong',
    imageUrl: 'https://readdy.ai/api/search-image?query=Fit%20woman%20doing%20yoga%20pose%20in%20bright%20minimalist%20home%20studio%2C%20morning%20sunlight%20streaming%20through%20window%2C%20light%20wooden%20floor%2C%20white%20walls%2C%20indoor%20plant%2C%20wellness%20lifestyle%20aesthetic%2C%20calm%20atmosphere&width=800&height=450&seq=featured-video-05&orientation=landscape',
    duration: '32:10',
    views: '176.5万',
    date: '2026-08-05',
    description: '适合初学者的居家瑜伽课程，30分钟高效燃脂，坚持练习塑造完美体态。',
  },
  {
    id: 'feat-6',
    title: '成都美食探店｜隐藏在巷子里的地道川味',
    category: '旅行美食',
    categorySlug: 'luxing-meishi',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20woman%20enjoying%20food%20at%20traditional%20Chinese%20restaurant%2C%20warm%20ambient%20lighting%2C%20wooden%20interior%2C%20steaming%20dishes%20on%20table%2C%20cozy%20atmosphere%2C%20food%20photography%20style%2C%20lifestyle%20dining%20scene&width=800&height=450&seq=featured-video-06&orientation=landscape',
    duration: '18:45',
    views: '143.8万',
    date: '2026-08-04',
    description: '带你走遍成都大街小巷，探寻最地道的川味美食，每一口都是惊喜。',
  },
];

export const hotVideos = [
  {
    id: 'hot-1',
    title: '一周穿搭不重样｜通勤约会出游全场景搭配',
    category: '时尚穿搭',
    categorySlug: 'shishang-chuanda',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stylish%20woman%20in%20multiple%20fashionable%20outfits%20laid%20out%2C%20minimalist%20white%20bedroom%20background%2C%20warm%20natural%20light%2C%20wardrobe%20planning%20flatlay%20style%2C%20modern%20fashion%20editorial%2C%20clean%20composition&width=800&height=450&seq=hot-video-01&orientation=landscape',
    duration: '10:18',
    views: '256.9万',
    date: '2026-08-09',
    isHot: true,
  },
  {
    id: 'hot-2',
    title: '樱花季和服写真｜京都春日浪漫之旅',
    category: '生活写真',
    categorySlug: 'shenghuo-xiezhen',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20woman%20in%20beautiful%20kimono%20under%20cherry%20blossom%20trees%2C%20spring%20season%2C%20soft%20pink%20petals%2C%20traditional%20Japanese%20garden%20background%2C%20warm%20sunlight%2C%20romantic%20atmosphere%2C%20lifestyle%20photography&width=800&height=450&seq=hot-video-02&orientation=landscape',
    duration: '09:42',
    views: '189.4万',
    date: '2026-08-08',
    isHot: true,
  },
  {
    id: 'hot-3',
    title: '钢琴弹奏《River Flows in You》完整版',
    category: '才艺展示',
    categorySlug: 'caiyi-zhanshi',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20woman%20playing%20grand%20piano%20in%20sunlit%20room%2C%20flowing%20dress%2C%20soft%20window%20light%2C%20classical%20music%20atmosphere%2C%20minimalist%20interior%2C%20artistic%20composition%2C%20warm%20tones&width=800&height=450&seq=hot-video-03&orientation=landscape',
    duration: '04:56',
    views: '312.1万',
    date: '2026-08-08',
    isHot: true,
  },
  {
    id: 'hot-4',
    title: '秋冬护肤全攻略｜干燥季节的保湿秘诀',
    category: '美容美妆',
    categorySlug: 'meirong-meizhuang',
    imageUrl: 'https://readdy.ai/api/search-image?query=Beautiful%20woman%20with%20skincare%20products%20on%20marble%20vanity%2C%20fresh%20clean%20skin%2C%20soft%20natural%20light%2C%20minimalist%20bathroom%20setting%2C%20wellness%20beauty%20aesthetic%2C%20white%20and%20cream%20tones&width=800&height=450&seq=hot-video-04&orientation=landscape',
    duration: '14:23',
    views: '167.3万',
    date: '2026-08-07',
    isHot: true,
  },
  {
    id: 'hot-5',
    title: '普拉提核心训练｜改善体态塑造小蛮腰',
    category: '健身运动',
    categorySlug: 'jianshen-yundong',
    imageUrl: 'https://readdy.ai/api/search-image?query=Fit%20woman%20doing%20pilates%20on%20reformer%20machine%2C%20bright%20airy%20studio%20with%20large%20windows%2C%20minimalist%20white%20interior%2C%20morning%20light%2C%20wellness%20fitness%20aesthetic%2C%20clean%20composition&width=800&height=450&seq=hot-video-05&orientation=landscape',
    duration: '25:08',
    views: '203.7万',
    date: '2026-08-07',
    isHot: false,
  },
  {
    id: 'hot-6',
    title: '东京涩谷逛街Vlog｜潮流圣地购物分享',
    category: '旅行美食',
    categorySlug: 'luxing-meishi',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stylish%20woman%20walking%20through%20Tokyo%20shopping%20district%2C%20colorful%20neon%20signs%20background%2C%20urban%20fashion%20vibe%2C%20bustling%20city%20street%2C%20modern%20lifestyle%2C%20afternoon%20light%2C%20travel%20photography&width=800&height=450&seq=hot-video-06&orientation=landscape',
    duration: '21:36',
    views: '134.2万',
    date: '2026-08-06',
    isHot: false,
  },
  {
    id: 'hot-7',
    title: '法式复古穿搭灵感｜经典永不过时的搭配法则',
    category: '时尚穿搭',
    categorySlug: 'shishang-chuanda',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20woman%20in%20French%20vintage%20style%20outfit%2C%20Parisian%20cafe%20background%2C%20warm%20afternoon%20light%2C%20classic%20fashion%20aesthetic%2C%20croissant%20and%20coffee%20on%20table%2C%20romantic%20atmosphere%2C%20soft%20bokeh&width=800&height=450&seq=hot-video-07&orientation=landscape',
    duration: '11:05',
    views: '198.7万',
    date: '2026-08-06',
    isHot: false,
  },
  {
    id: 'hot-8',
    title: '吉他弹唱《晴天》｜温暖治愈的午后时光',
    category: '才艺展示',
    categorySlug: 'caiyi-zhanshi',
    imageUrl: 'https://readdy.ai/api/search-image?query=Beautiful%20woman%20playing%20acoustic%20guitar%20by%20sunny%20window%2C%20cozy%20room%20with%20plants%2C%20warm%20afternoon%20light%2C%20casual%20outfit%2C%20music%20lifestyle%20aesthetic%2C%20wooden%20floor%2C%20relaxed%20atmosphere&width=800&height=450&seq=hot-video-08&orientation=landscape',
    duration: '05:30',
    views: '278.4万',
    date: '2026-08-05',
    isHot: false,
  },
];

export const latestVideos = [
  {
    id: 'latest-1',
    title: '2026秋季新品开箱｜最值得入手的时尚单品',
    category: '时尚穿搭',
    categorySlug: 'shishang-chuanda',
    imageUrl: 'https://readdy.ai/api/search-image?query=Beautiful%20woman%20unboxing%20fashion%20items%20on%20clean%20white%20desk%2C%20shopping%20bags%20and%20new%20clothes%2C%20bright%20natural%20light%2C%20minimalist%20bedroom%20background%2C%20fashion%20haul%20style%2C%20excited%20expression&width=800&height=450&seq=latest-video-01&orientation=landscape',
    duration: '13:20',
    views: '45.6万',
    date: '2026-08-09',
    isNew: true,
  },
  {
    id: 'latest-2',
    title: '傍晚城市漫步｜治愈系生活Vlog',
    category: '生活写真',
    categorySlug: 'shenghuo-xiezhen',
    imageUrl: 'https://readdy.ai/api/search-image?query=Beautiful%20woman%20walking%20through%20city%20street%20at%20golden%20hour%2C%20warm%20sunset%20light%2C%20urban%20background%2C%20casual%20stylish%20outfit%2C%20lifestyle%20photography%2C%20calm%20and%20peaceful%20mood&width=800&height=450&seq=latest-video-02&orientation=landscape',
    duration: '07:55',
    views: '32.1万',
    date: '2026-08-09',
    isNew: true,
  },
  {
    id: 'latest-3',
    title: '街舞编舞作品《Fire》｜力量与美感并存',
    category: '才艺展示',
    categorySlug: 'caiyi-zhanshi',
    imageUrl: 'https://readdy.ai/api/search-image?query=Energetic%20woman%20dancing%20street%20dance%20in%20urban%20studio%2C%20dynamic%20pose%2C%20industrial%20loft%20background%2C%20dramatic%20lighting%2C%20hip%20hop%20style%2C%20powerful%20movement%2C%20modern%20dance%20aesthetic&width=800&height=450&seq=latest-video-03&orientation=landscape',
    duration: '04:12',
    views: '67.8万',
    date: '2026-08-09',
    isNew: true,
  },
  {
    id: 'latest-4',
    title: '眼部遮瑕大法｜告别黑眼圈泪沟困扰',
    category: '美容美妆',
    categorySlug: 'meirong-meizhuang',
    imageUrl: 'https://readdy.ai/api/search-image?query=Beautiful%20woman%20demonstrating%20concealer%20makeup%20technique%20close%20up%2C%20flawless%20skin%2C%20beauty%20mirror%20reflection%2C%20bright%20vanity%20lighting%2C%20minimalist%20setup%2C%20professional%20beauty%20tutorial&width=800&height=450&seq=latest-video-04&orientation=landscape',
    duration: '09:38',
    views: '28.9万',
    date: '2026-08-09',
    isNew: true,
  },
];

export const faqs = [
  {
    question: '这个网站的视频都是免费观看的吗？',
    answer: '是的，本站所有视频内容均免费在线观看，无需注册或付费。我们致力于为用户提供高质量的精选视频内容，每日更新，让您随时随地享受精彩视频。',
  },
  {
    question: '视频内容多久更新一次？',
    answer: '我们保持每日更新的频率，每天都会精选最新、最热门的视频内容推送到首页。涵盖时尚穿搭、生活写真、才艺展示、美容美妆、健身运动、旅行美食等多个分类。',
  },
  {
    question: '如何快速找到我感兴趣的视频？',
    answer: '您可以通过首页顶部的分类导航快速筛选感兴趣的内容类型。每个分类下都有相应的视频合集，也可以使用搜索功能（即将上线）精准查找您想看的内容。',
  },
  {
    question: '视频支持高清画质播放吗？',
    answer: '所有视频均支持高清画质播放，我们精选的视频都经过画质筛选，确保为您提供最佳的观看体验。建议在稳定的网络环境下观看以获得流畅体验。',
  },
  {
    question: '可以在手机上看视频吗？',
    answer: '当然可以！我们的网站采用响应式设计，完美适配手机、平板和电脑等各种设备。无论您使用哪种设备，都能获得流畅舒适的观看体验。',
  },
  {
    question: '如何向我们推荐优秀的视频内容？',
    answer: '您可以通过「关于我们」页面的联系表单与我们取得联系，分享您喜欢的视频内容或创作者。我们非常期待收到您的推荐和建议！',
  },
];

export const stats = [
  { label: '精选视频', value: '12,800+', icon: 'ri-video-line' },
  { label: '内容分类', value: '6大', icon: 'ri-stack-line' },
  { label: '日均更新', value: '20+', icon: 'ri-refresh-line' },
  { label: '累计播放', value: '3.6亿+', icon: 'ri-play-circle-line' },
];